module.exports = __webpack_public_path__ + "static/media/Practice.afcae7a7.jpg";